import {t} from '../../../services/localization/localizationService';
import {twx} from '../../../utils/tailwindUtils';
import AiAssistantSettingCard from './AiAssistantSettingCard';

// Device icons set their own `dark:` fill, hence the `!`
const SegmentedOption = ({titleStrCode, Icon, isActive, onSelect}) => (
    <button type='button' onClick={onSelect} className='flex flex-1 flex-col items-center gap-2'>
        <span
            className={twx(
                'flex h-12 w-12 items-center justify-center rounded-full transition-colors duration-300',
                isActive ? 'bg-color-romance' : 'border border-white/30'
            )}
        >
            <Icon className={twx('h-6 w-6', isActive ? '[&_path]:!fill-[#2A2A2B]' : '[&_path]:!fill-color-romance')} />
        </span>

        <span className='text-12 text-[#FFFDFB]'>{t(titleStrCode)}</span>
    </button>
);

const AiAssistantSettingSegmentedTile = ({setting: {titleStrCode, options}, value, onChange}) => (
    <AiAssistantSettingCard className='flex-col'>
        <span className='text-14 text-[#FFFDFB]'>{t(titleStrCode)}</span>

        <div className='flex gap-2'>
            {options.map((option) => (
                <SegmentedOption
                    key={option.value}
                    titleStrCode={option.titleStrCode}
                    Icon={option.Icon}
                    isActive={option.value === value}
                    onSelect={() => onChange(option.value)}
                />
            ))}
        </div>
    </AiAssistantSettingCard>
);

export default AiAssistantSettingSegmentedTile;
